import type {FC} from 'react';
import React from 'react';

import type {ContainerSpacing} from '@/modules/foundation/components/container';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import type {DocumentInCard} from './DocumentCardGrid';
import DocumentCardGrid from './DocumentCardGrid';

type Props = {
	heading?: string;
	tagline?: string;
	documents?: KeyedArray<DocumentInCard>;
	spacingTop?: ContainerSpacing;
	spacingBottom?: ContainerSpacing;
};

export const DocumentListSelection: FC<Props> = ({...props}) => {
	return <DocumentCardGrid {...props} />;
};
